export default __webpack_public_path__ + "static/media/Trustly.271f40a3.svg";